import Helper from '@ember/component/helper';
import { service } from '@ember/service';

export default class HasPermissionHelper extends Helper {
  @service access;

  compute([permission]) {
    return this.access.hasPermission(permission);
  }
}
